const setMetaData = ({ title = null, description = null }) => {
  const div = document.createElement('div');

  const defaultTitle = 'Swish Developer Documentation';
  const defaultDescription =
    'Developer documentation for implementing Swish as a payment method for your business.';

  document.querySelector('meta[property="og:url"]').setAttribute('content', window.location.href);

  if (title) {
    div.innerHTML = title;
    document.title = div.innerText;
    document.querySelector('meta[property="og:title"]').setAttribute('content', div.innerText);
  } else {
    document.title = defaultTitle;
    document.querySelector('meta[property="og:title"]').setAttribute('content', defaultTitle);
  }

  if (description) {
    const firstParagraph = description.split('</p>')[0]; // If there are multiple paragraphs we use the first one
    const firstLine = firstParagraph.split('\n')[0]; // If there are multiple lines we use the first one
    div.innerHTML = firstLine;

    document.querySelector('meta[name="description"]').setAttribute('content', div.innerText);
    document
      .querySelector('meta[property="og:description"]')
      .setAttribute('content', div.innerText);
  } else {
    document.querySelector('meta[name="description"]').setAttribute('content', defaultDescription);
    document
      .querySelector('meta[property="og:description"]')
      .setAttribute('content', defaultDescription);
  }
};

export default setMetaData;
